/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc
 */
import * as References from './UniversalRecordingReviewExternalRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#validateToken
 */
export const VALIDATE_TOKEN_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_validateToken';
export const VALIDATE_TOKEN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: VALIDATE_TOKEN_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.validateTokenRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#getEngagementDetails
 */
export const GET_ENGAGEMENT_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_getEngagementDetails';
export const GET_ENGAGEMENT_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ENGAGEMENT_DETAILS_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getEngagementDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#getNotes
 */
export const GET_NOTES_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_getNotes';
export const GET_NOTES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_NOTES_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getNotesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#getRecording
 */
export const GET_RECORDING_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_getRecording';
export const GET_RECORDING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RECORDING_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getRecordingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#getTranscript
 */
export const GET_TRANSCRIPT_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_getTranscript';
export const GET_TRANSCRIPT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TRANSCRIPT_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getTranscriptRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#getSummary
 */
export const GET_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_getSummary';
export const GET_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUMMARY_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#getActionItems
 */
export const GET_ACTION_ITEMS_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_getActionItems';
export const GET_ACTION_ITEMS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTION_ITEMS_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getActionItemsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc#getQAndA
 */
export const GET_QAND_A_QUERY_FIELD_NAME = 'com_hubspot_universal_recording_review_be_rpc_UniversalRecordingReviewExternalRpc_getQAndA';
export const GET_QAND_A_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QAND_A_QUERY_FIELD_NAME,
  args: ['accessToken'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getQAndARpc, {
      timeout: ctx.timeout,
      request
    });
  }
});